export const CommunicationStatus = {
	declined: 'declined',
	accepted: 'accepted',
	dismissed: 'dismissed',
	cancelled: 'cancelled',
	unknown: 'unknown',
}